import { Component } from '@angular/core';
import { OneFeildMasterService } from '../../Model/OneFeildMasters/one-feild-master.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ShareTypeService } from '../../Model/OneFeildMasters/share-type.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService } from '../../Util/Toast/toast.service';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule } from '@angular/forms';
import { AddMasterComponent } from '../add-master/add-master.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-all-masters',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule],
  templateUrl: './all-masters.component.html',
  styleUrl: './all-masters.component.scss'
})
export class AllMastersComponent {
  SelectType: string = '';
  isDisabled: boolean = false;
  OneFeildData = [];
  editMode: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();

  Details = {
    ID: 0,
    Name: '',
    Active: ''
  }

  Div: string = '';
  divVisibilityMap: { [key: string]: boolean } = {
    'countrymaster': false,
    'gunmaster': false,
    'reason': false,
    'color': false,
    'uniform': false,
    'shoe': false,
    'designationgrp': false,
    'qualification': false,
    'religion': false,
    'mother': false,
    'relationship': false,
    'caste': false,
    'nationality': false,
    'language': false,
    'designationctgry': false,
    'report': false,
    'group': false,
    'duty': false,
    'rateapplication': false,
  };
  dtoptions: DataTables.Settings = {};
  constructor(private router: Router,
    private oneFeildservie: OneFeildMasterService,
    private sharetype: ShareTypeService,
    private sessionService: SessionService,
    private toast: ToastService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    protected common: CommonService
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    const TypeOfSigleFieldMaster = sessionStorage.getItem('TypeOfSingleFieldMaster');
    console.log(TypeOfSigleFieldMaster);
    if (TypeOfSigleFieldMaster != null) {
      this.SelectType = TypeOfSigleFieldMaster
      this.getData(this.SelectType);
      this.route.url.subscribe(segments => {
        const path = segments[segments.length - 1].path;
        this.Div = path;
        console.log('div data for eee', this.Div);
        const divKey = this.Div.toLowerCase();
        const isVisible = this.divVisibilityMap[this.Div];

        if (isVisible !== undefined) {
          this.divVisibilityMap[divKey] = true;
          Object.keys(this.divVisibilityMap).forEach(key => {
            if (key !== divKey) {
              this.divVisibilityMap[key] = false;
            }
          });
        }
      });
    }
    this.editMode = false;
  }
  getData(value: string) {
    const ofmData = {
      SelectType: value,
      ID: '0',
      LoginUserID: '0',
      ClientID: '0',
      DesignationID: '',
      GroupID: '',
      DutyID: '',
      BankAccountNo: '',
      BranchID: '',
      FinancialYear: '',
    };
    this.isDisabled = true;
    this.oneFeildservie.OneFeildLoad(ofmData).subscribe({
      next: (data) => {
        this.OneFeildData = data.DataTable.Table;
        this.dtTrigger.next(null);
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
        console.error('Error:', error);
      },
    });
  }

  navigateToLocationComponent() {
    this.editMode = false
    this.sharetype.SEditMode(this.editMode);
    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(AddMasterComponent, modalOptions);
    modalRef.result.then(
      (result) => {
        this.reloadPage();
      },
      (reason) => {

        this.reloadPage();
      }
    );
  }

  Open() {
    this.sharetype.SEditMode(this.editMode);
    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(AddMasterComponent, modalOptions);
    modalRef.result.then(
      (result) => {
        this.reloadPage();
      },
      (reason) => {
        this.reloadPage();
      }
    );
  }

  reloadPage() {
    window.location.reload();
  }

  click(selectType: string, Details: any) {
    if (selectType === 'country') {
      this.editMode = true;
      this.Details.ID = Details.CountryMasterID;
      this.Details.Name = Details.CountryName;
      this.Details.Active = Details.Active;
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'Gun') {
      this.editMode = true;
      this.Details.ID = Details.TypeofGunMasterID;
      this.Details.Name = Details.TypeofGunName;
      this.Details.Active = Details.Active;
      console.log('Gun Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'reason') {
      this.editMode = true;
      this.Details.ID = Details.ReasonMasterID;
      this.Details.Name = Details.ReasonName;
      this.Details.Active = Details.Active;
      console.log('reason Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'color') {
      this.editMode = true;
      this.Details.ID = Details.ColourMasterID;
      this.Details.Name = Details.ColourName;
      this.Details.Active = Details.Active;
      console.log('color Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'uniform') {
      this.editMode = true;
      this.Details.ID = Details.UniformSizeMasterID;
      this.Details.Name = Details.UniformSizeName;
      this.Details.Active = Details.Active;
      console.log('uniform Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'shoes') {
      this.editMode = true;
      this.Details.ID = Details.ShoesSizeMasterID;
      this.Details.Name = Details.ShoesSizeName;
      this.Details.Active = Details.Active;
      console.log('shoes Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'desigrp') {
      this.editMode = true;
      this.Details.ID = Details.DesignationGroupMasterID;
      this.Details.Name = Details.DesignationGroupName;
      this.Details.Active = Details.Active;
      console.log('desigrp Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'qualification') {
      this.editMode = true;
      this.Details.ID = Details.QualificationMasterID;
      this.Details.Name = Details.QualificationName;
      this.Details.Active = Details.Active;
      console.log('qualification Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));

    }
    else if (selectType === 'religion') {
      this.editMode = true;
      this.Details.ID = Details.ReligionMasterID;
      this.Details.Name = Details.ReligionName;
      this.Details.Active = Details.Active;
      console.log('religion Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));

    }
    else if (selectType === 'mother') {
      this.editMode = true;
      this.Details.ID = Details.MotherTongueMasterID;
      this.Details.Name = Details.MotherTongueName;
      this.Details.Active = Details.Active;
      console.log('mother Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'relation') {
      this.editMode = true;
      this.Details.ID = Details.RelationshipMasterID;
      this.Details.Name = Details.RelationshipName;
      this.Details.Active = Details.Active;
      console.log('relation Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'caste') {
      this.editMode = true;
      this.Details.ID = Details.CasteMasterID;
      this.Details.Name = Details.CasteName;
      this.Details.Active = Details.Active;
      console.log('caste Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'nationality') {
      this.editMode = true;
      this.Details.ID = Details.NationalityMasterID;
      this.Details.Name = Details.NationalityName;
      this.Details.Active = Details.Active;
      console.log('nationality Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'language') {
      this.editMode = true;
      this.Details.ID = Details.LanguageMasterID;
      this.Details.Name = Details.LanguageName;
      this.Details.Active = Details.Active;
      console.log('language Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'category') {
      this.editMode = true;
      this.Details.ID = Details.DesignationCategoryMasterID;
      this.Details.Name = Details.DesignationCategoryName;
      this.Details.Active = Details.Active;
      console.log('category Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'report') {
      this.editMode = true;
      this.Details.ID = Details.ReportTypeMasterID;
      this.Details.Name = Details.ReportTypeName;
      this.Details.Active = Details.Active;
      console.log('report Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'group') {
      this.editMode = true;
      this.Details.ID = Details.GroupMasterID;
      this.Details.Name = Details.GroupName;
      this.Details.Active = Details.Active;
      console.log('group Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'duty') {
      this.editMode = true;
      this.Details.ID = Details.DutyMasterID;
      this.Details.Name = Details.DutyName;
      this.Details.Active = Details.Active;
      console.log('duty Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    else if (selectType === 'rate') {
      this.editMode = true;
      this.Details.ID = Details.RateApplicableID;
      this.Details.Name = Details.RateApplicableName;
      this.Details.Active = Details.Active;
      console.log('rate Details:', Details);
      sessionStorage.setItem('Details', JSON.stringify(this.Details));
    }
    this.sharetype.SEditMode(this.editMode);
    this.Open();
  }
}
